import * as jose from 'jose'

export const upvotyKey = 'pVGGdIF4ysjcSqmaqE4lCjX7svEY3E4j'

export interface UpvotyUser {
    // Required, Unique identifier for this user
    id: string
    // Required, The full name for this user
    name: string
    // The user's email address
    email?: string
    // Optional: The URL to the user's avatar
    avatar?: string
}

export const createUpvotyToken = async (user: UpvotyUser) => {
    const token = new jose.SignJWT(user as unknown as jose.JWTPayload)
                    .setProtectedHeader({ alg: 'HS256' })
                    .setIssuer("https://dashboard.momento.nl/login")
                    .setAudience("momento.upvotyfeedback.com")
                    .sign(new TextEncoder().encode(upvotyKey))
    return await token
}
